export default __webpack_public_path__ + "static/media/icon-flag-czech-republic.d921bcc5.svg";